var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotVerified(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 90,
    viewBox: "0 0 80 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EF504E",
    fillRule: "nonzero",
    strokeWidth: 3.75,
    d: "M39.87 87.5L21.554 74.19A45.75 45.75 0 0 1 2.706 38.055l-.534-27.927c21.2 0 33.765-2.63 37.693-7.888 4.086 5.258 16.657 7.888 37.713 7.888l-.533 27.923a45.75 45.75 0 0 1-18.853 36.14L39.87 87.5z"
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.044 32.236l19.707 19.891M49.843 32.373L29.952 52.08"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotVerified);
export default __webpack_public_path__ + "static/media/not_verified.31989bde7e0886de0dcbb8fdfc84e302.svg";
export { ForwardRef as ReactComponent };